/* Carrito lateral · Amanda Cousiño */
(function () {
  if (window.ACCart) return;
  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  function money(c) { return fmt.format((c || 0) / 100); }
  function $(id) { return document.getElementById(id); }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  var drawer, pan, scroller, lastFocus, busy = false, lastY = 0;

  function showOffer() { var of = $('acdOffer'); if (of) of.classList.remove('is-hid'); }

  function setCount(n) {
    document.querySelectorAll('#sj-home .ac-icons a[href="/cart"]').forEach(function (a) {
      var s = a.querySelector('.ac-cc');
      if (!s) { s = el('span', 'ac-cc'); a.appendChild(s); }
      if (n > 0) { s.textContent = n; s.hidden = false; a.setAttribute('aria-label', 'Carrito, ' + n + ' productos'); }
      else { s.hidden = true; a.setAttribute('aria-label', 'Carrito'); }
    });
  }

  function msg(t) { var m = $('acdMsg'); if (!m) return; m.textContent = t || ''; m.hidden = !t; }

  function offer(n) {
    var box = $('acdOffer'), txt = $('acdOfferTxt'), fill = $('acdBarFill');
    if (!box) return;
    box.hidden = n === 0;
    var t;
    if (n === 1) t = 'Añade 1 prenda más y ahorra un 10 %';
    else if (n === 2) t = '¡-10 % aplicado! Añade 1 prenda más para el -15 %';
    else if (n === 3) t = '¡-15 % aplicado! Añade 1 prenda más para el -20 %';
    else t = '¡Tienes el máximo descuento: -20 %!';
    txt.textContent = t;
    fill.style.width = (Math.min(n, 4) * 25) + '%';
    box.querySelectorAll('.acd-steps span').forEach(function (s, i) { s.classList.toggle('on', n >= i + 2); });
  }

  function imgUrl(u) {
    if (!u) return '';
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=200';
  }

  function recs(skip, title) {
    var rs = $('acdRecs');
    if (!rs) return null;
    var c = rs.cloneNode(true); c.removeAttribute('id'); c.hidden = false;
    var n = 0;
    c.querySelectorAll('.acd-rc').forEach(function (a) {
      if (n >= 4 || skip.indexOf(Number(a.getAttribute('data-pid'))) > -1) a.remove(); else n++;
    });
    if (!n) return null;
    if (title) { c.classList.add('acd-more'); c.querySelector('.acd-recs-t').textContent = title; }
    return c;
  }

  function render(cart) {
    var list = $('acdItems'), foot = $('acdFoot');
    if (!list) return;
    list.textContent = '';
    $('acdN').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    setCount(cart.item_count);
    offer(cart.item_count);
    if (!cart.item_count) {
      var e = el('div', 'acd-empty');
      e.appendChild(el('p', 'acd-empty-t', 'Tu carrito está vacío'));
      e.appendChild(el('p', null, 'Echa un vistazo a lo último que ha llegado.'));
      var rc = recs([]);
      if (rc) e.appendChild(rc);
      var a = el('a', 'acd-go', 'VER NOVEDADES'); a.href = '/collections/novedades';
      e.appendChild(a);
      list.appendChild(e);
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    cart.items.forEach(function (it) {
      var row = el('div', 'acd-it');
      var ia = el('a', 'acd-img'); ia.href = it.url;
      if (it.image) { var im = el('img'); im.src = imgUrl(it.image); im.alt = it.product_title; im.width = 90; im.height = 120; im.loading = 'lazy'; ia.appendChild(im); }
      row.appendChild(ia);
      var info = el('div', 'acd-info');
      var parts = String(it.product_title).split(' — ');
      if (parts.length === 1) parts = String(it.product_title).split(' | ');
      var tl = el('a', 'acd-name', parts[0]); tl.href = it.url; info.appendChild(tl);
      if (parts[1]) info.appendChild(el('p', 'acd-sub', parts[1]));
      if (it.options_with_values && !it.product_has_only_default_variant) {
        info.appendChild(el('p', 'acd-var', it.options_with_values.map(function (o) { return o.name + ': ' + o.value; }).join(' · ')));
      }
      var pr = el('p', 'acd-price');
      if (it.original_line_price !== it.final_line_price) { pr.appendChild(el('s', null, money(it.original_line_price))); pr.appendChild(document.createTextNode(' ')); }
      pr.appendChild(el('b', null, money(it.final_line_price)));
      info.appendChild(pr);
      var q = el('div', 'acd-qty');
      var minus = el('button', null, '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Quitar una unidad');
      var val = el('span', null, String(it.quantity));
      var plus = el('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Añadir una unidad');
      minus.addEventListener('click', function () { change(it.key, it.quantity - 1); });
      plus.addEventListener('click', function () { change(it.key, it.quantity + 1); });
      q.appendChild(minus); q.appendChild(val); q.appendChild(plus);
      var rm = el('button', 'acd-rm', 'Eliminar'); rm.type = 'button';
      rm.addEventListener('click', function () { change(it.key, 0); });
      var line = el('div', 'acd-line'); line.appendChild(q); line.appendChild(rm);
      info.appendChild(line);
      row.appendChild(info);
      list.appendChild(row);
    });
    var more = recs(cart.items.map(function (it) { return it.product_id; }), 'NOVEDADES');
    if (more) list.appendChild(more);
    var disc = cart.original_total_price - cart.total_price;
    $('acdSub').textContent = money(cart.original_total_price);
    $('acdDiscRow').hidden = !(disc > 0);
    $('acdDisc').textContent = '-' + money(disc);
    $('acdTotal').textContent = money(cart.total_price);
  }

  function load() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
  }

  function change(key, qty) {
    if (busy) return; busy = true; pan.classList.add('is-busy'); msg('');
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(render)
      .catch(function (e) { msg((e && (e.description || e.message)) || 'No se ha podido actualizar el carrito.'); load(); })
      .then(function () { busy = false; pan.classList.remove('is-busy'); });
  }

  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('acd-lock');
    showOffer();
    void drawer.offsetWidth; drawer.classList.add('is-open');
    var x = drawer.querySelector('.acd-x'); if (x) x.focus();
  }
  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('acd-lock');
    setTimeout(function () { drawer.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function add(formData, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'AÑADIENDO…'; }
    msg('');
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return load(); })
      .then(function () { showOffer(); open(); })
      .catch(function (e) { load().then(open); msg((e && (e.description || e.message)) || 'No se ha podido añadir el producto.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }

  function init() {
    drawer = $('acDrawer'); if (!drawer) return;
    pan = drawer.querySelector('.acd-pan');
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
    scroller = $('acdScroll');
    if (scroller) scroller.addEventListener('scroll', function () {
      var of = $('acdOffer'); if (!of) return;
      var y = scroller.scrollTop;
      if (y <= of.offsetHeight) of.classList.remove('is-hid');
      else if (y > lastY + 4) of.classList.add('is-hid');
      else if (y < lastY - 4) of.classList.remove('is-hid');
      lastY = y;
    }, { passive: true });
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-acd-close]')) { e.preventDefault(); close(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var onCart = /^\/cart\/?$/.test(location.pathname);
    window.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#sj-home .ac-icons a[href="/cart"]');
      if (a && !onCart) { e.preventDefault(); load().then(open); return; }
      var ab = e.target.closest && e.target.closest('#pdAdd, #pdStickBtn');
      if (ab) {
        var fm = $('pdForm'), mainBtn = $('pdAdd');
        if (!fm || (mainBtn && mainBtn.disabled) || ab.disabled) return;
        e.preventDefault(); e.stopPropagation();
        add(new FormData(fm), mainBtn || ab);
        return;
      }
      var pk = e.target.closest && e.target.closest('#pdPackGo');
      if (pk) {
        var f = $('pdForm'), addBtn = $('pdAdd');
        if (!f || (addBtn && addBtn.disabled)) return;
        e.preventDefault(); e.stopPropagation();
        add(new FormData(f), pk);
      }
    }, true);

    window.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.id !== 'pdForm') return;
      e.preventDefault(); e.stopImmediatePropagation();
      var b = $('pdAdd');
      if (b && b.disabled) return;
      add(new FormData(f), b);
    }, true);

    load().catch(function () {});
  }

  window.ACCart = { open: function () { load().then(open); }, close: close, refresh: load };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
